export const isBrowserIE = (): boolean => {
  const agent = window.navigator.userAgent;

  return (
    /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/i.test(agent) ||
    /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/i.test(agent) ||
    /MSIE\s(7\.0)/i.test(agent)
  );
};
